import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import http from '@/api/http'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)

app.config.globalProperties.$http = http

app.use(store)
    .use(router)
    .use(ElementPlus)
    .mount('#app')
